import { Link, useLocation } from "react-router-dom";

const tabs = [
  { to: "/", label: "首页", icon: "ri-home-5-line" },
  { to: "/category", label: "分类", icon: "ri-layout-grid-line" },
  { to: "/search", label: "搜索", icon: "ri-search-line" },
  { to: "/about", label: "关于", icon: "ri-information-line" },
];

export default function MobileTabBar() {
  const location = useLocation();

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-background-100/95 backdrop-blur border-t border-background-200/60 pb-[env(safe-area-inset-bottom)]">
      <div className="flex items-stretch justify-around">
        {tabs.map((tab) => {
          const active =
            tab.to === "/"
              ? location.pathname === "/"
              : location.pathname.startsWith(tab.to);
          return (
            <Link
              key={tab.to}
              to={tab.to}
              className={`flex flex-col items-center justify-center gap-1 py-2.5 flex-1 transition-colors ${
                active ? "text-accent-500" : "text-foreground-500"
              }`}
            >
              <span className="w-7 h-7 flex items-center justify-center">
                <i className={`${tab.icon} text-xl`} />
              </span>
              <span className="text-[11px] whitespace-nowrap">{tab.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}